export default function MaskedView({
  children
}) {
  return children;
}
//# sourceMappingURL=MaskedView.js.map